export default __webpack_public_path__ + "static/labs-d526943392c00244d2b0e637372df59f.mp4";